import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import { defaultTheme } from "solveiq.designsystem";
import { ThemeProvider } from "@material-ui/core";
import English from "./compiled-lang/en.json";
import German from "./compiled-lang/de.json";
import { IntlProvider } from "react-intl";

const locale = navigator.language;
let lang;
if (locale === "de") {
  lang = German;
} else {
  lang = English;
}

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider
      locale={locale}
      defaultLocale={"en"}
      messages={lang}
      // opt out of all errors for the near-term.
      // this is a stop gap for silencing the console spam
      // generated by intl because the migrated <FormattedMessage> elements
      // contain explicit IDs. The fix for this is to remove all the IDs
      // from those elements. Intl will generate ids underneath the covers.
      onError={() => {}}
    >
      <Router basename={(window as any).basename}>
        <ThemeProvider theme={defaultTheme}>
          <App />
        </ThemeProvider>
      </Router>
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
